import React from 'react';
import ForgotPassword from '../../components/auth/ForgotPassword/ForgotPassword';
import './ForgotPasswordPage.css';

const ForgotPasswordPage = () => {
  return (
    <div className="forgot-password-page">
      <ForgotPassword />
    </div>
  );
};

export default ForgotPasswordPage;